<template>
  <FormPto
    v-model="modelFormData"
    :is-edit="isEdit"
    :is-sending="isSending"
    :clear-on-destroy="!isEdit"
    @request="onSubmit"
    @cancel="onCancel"
  >
    <PTOProjectTitle v-if="isEdit" is-edit />

    <VSelect
      label="Вид работ"
      name="job_type"
      :items="jobTypeList"
      :handler-search="GETJobTypeList"
      search
      required
    >
      <Validation for="required">Поле обязательно</Validation>
    </VSelect>

    <VInput
      label="Стоимость"
      name="price"
      pattern="^\d*(?:[.]\d{0,3})?$"
      :required="isPlaning"
    >
      <Validation for="required">Поле обязательно</Validation>
      <Validation for="pattern">Формат ввода: "1000.001"</Validation>
    </VInput>

    <VInput
      label="Объем работ"
      name="work_scope"
      pattern="^\d*(?:[.]\d{0,3})?$"
      :required="isPlaning"
    >
      <Validation for="required">Поле обязательно</Validation>
      <Validation for="pattern">Формат ввода: "1000.001"</Validation>
    </VInput>

    <VSelect
      label="Ед. изм."
      name="measure_unit"
      :items="measureUnitList"
      :handler-search="GETMeasureUnitList"
      search
    />

    <AppInputDate
      title="Дата начала работ"
      name="start_date"
      type="single"
      :required="isPlaning"
    >
      <Validation for="required">Поле обязательно</Validation>
    </AppInputDate>

    <AppInputDate
      title="Дата окончания работ"
      name="stop_date"
      type="single"
      :required="isPlaning"
    >
      <Validation for="required">Поле обязательно</Validation>
    </AppInputDate>

    <div class="form__input--col-2 form__input--grid">
      <AppRadio
        title="Мол"
        name="is_mol"
        :checked="isMol"
        @toggle-check="isMol = true"
      />
      <AppRadio
        title="Подрядчик"
        name="is_no_mol"
        :checked="!isMol"
        @toggle-check="isMol = false"
      />
    </div>

    <VSelect
      label="Исполнитель"
      :name="isMol ? 'executor' : 'executor_contract'"
      ref="selectExecutor"
      :item-text="isMol ? 'name' : 'long_name'"
      :items="executorList"
      :handler-search="isMol ? GETUserList : GETPartnerList"
      search
      required
      userSelect
    >
      <Validation for="required">Поле обязательно</Validation>
    </VSelect>

    <transition name="fade">
      <VInput
        v-if="!isMol"
        label="Ген. подряд к получению"
        name="general_contract"
      />
    </transition>

    <transition name="fade">
      <VSelect
        v-if="!isMol"
        label="Договор"
        name="treaty"
        item-text="treaty_number"
        :items="contractsList"
        :handler-search="GETContractsList"
        search
      />
    </transition>

    <VInput
      label="Описание"
      class="form__input--col-2"
      name="description"
      type="textarea"
    />

    <VInput
      label="Примечание"
      class="form__input--col-2"
      name="note"
      type="textarea"
    />

    <VCheckbox
      title="Запланировать равномерно"
      name="is_plan_evenly"
      type="switch"
      :checked="isPlan"
      @toggle-check="planEvenly()"
    />
  </FormPto>
</template>

<script>
import AppInputDate from '@/components/page/input/AppInputDate'
import AppRadio from '@/components/page/input/AppRadio'
import FormPto from '@/components/pto/form/FormPto'
import PTOProjectTitle from '@/components/pto/title/PTOProjectTitle'
import Validation from '@/components/page/Form/Validation.vue'
import VCheckbox from '@/components/page/Form/VCheckbox/VCheckbox'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import VSelect from '@/components/page/Form/VSelect.vue'

import { MIXIN_FORM_PTO } from '@/mixins/module/pto/mixinFormPto'
import { MIXIN_USER_LIST } from '@/mixins/handbook/userList'

import { mapActions, mapState } from 'vuex'
import { prepareProjectPtoJobFormData } from '@/utils/page/pto/project/pto'

export default {
  name: 'FormPtoProjectPtoJob',
  components: {
    AppRadio,
    AppInputDate,
    FormPto,
    PTOProjectTitle,
    // eslint-disable-next-line vue/no-unused-components
    Validation,
    VCheckbox,
    VInput,
    VSelect
  },

  mixins: [
    MIXIN_FORM_PTO,
    MIXIN_USER_LIST
  ],

  data: () => ({
    isMol: true,
    isPlan: false
  }),

  computed: {
    ...mapState('handbook/pto', {
      jobTypeList: 'jobTypeList',
      measureUnitList: 'measureUnitList'
    }),
    ...mapState('handbook/partner', {
      partnerList: 'partnerList'
    }),
    ...mapState('handbook/contracts', {
      contractsList: 'contractsList'
    }),
    executorList () {
      if (this.isMol) return this.userList

      return this.partnerList
    },
    isPlaning () {
      return this.isPlan
    }
  },

  watch: {
    isMol () {
      this.$refs.selectExecutor.onClear()
    }
  },

  methods: {
    ...mapActions({
      GETContractsList: 'handbook/contracts/GETContractsList',
      GETPartnerList: 'handbook/partner/GETPartnerList'
    }),
    ...mapActions('handbook/pto', {
      GETJobTypeList: 'GETJobTypeList',
      GETMeasureUnitList: 'GETMeasureUnitList'
    }),
    onSubmit (data) {
      this.$emit('request', prepareProjectPtoJobFormData({
        ...data,
        is_mol: this.isMol
      }))
    },
    planEvenly () {
      this.isPlan = !this.isPlan
    }
  }
}
</script>
